import icTop from "@/assets/images/user/icTop.svg";
import logoFooter from "@/assets/images/user/logoFooter.svg";

import SnsLink from "./SnsLink";

export default function Footer() {
    // 스크롤위치 맨위로 이동
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <footer className="relative">
            <button
                type="button"
                className="absolute size-[50px] right-[20px] top-0 -translate-y-1/2 bg-primary flex flex-col gap-[4px] justify-center items-center md:size-[100px] md:left-1/2 md:-translate-x-1/2 md:gap-[12px]"
                onClick={handleScrollToTop}
            >
                <img src={icTop} alt="화살표" className="h-[8px] md:h-auto" />
                <p className="text-white font-['Handjet'] md:text-[24px]">TOP</p>
            </button>
            <div className="bg-[#000] py-[25px] md:py-[40px] xl:py-[60px]">
                <div className="relative max-w-[1400px] w-full mx-auto px-[16px] md:px-[20px] xl:flex xl:justify-between xl:items-start xl:px-0">
                    <div className="flex flex-col items-start gap-[20px] md:gap-[28px] xl:flex-row xl:items-center xl:gap-[40px]">
                        <img src={logoFooter} alt="GXG" />
                        <div className="hidden xl:block xl:w-[1px] xl:h-[32px] xl:bg-white" />
                        <SnsLink />
                    </div>
                    <ul className="w-full flex flex-col gap-[9px] text-white py-[24px] text-[14px] md:text-[16px] md:py-[36px] xl:max-w-[600px] xl:py-0">
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">COMPANY</b>
                            <span>(재) 게임문화재단</span>
                        </li>
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">ADDRESS</b>
                            <span>서울특별시 서초구 방배로 114, 2층</span>
                        </li>
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">대표자</b>
                            <span>유병한</span>
                        </li>
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">사업자등록번호</b>
                            <span>105-82-16443</span>
                        </li>
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">E-mail</b>
                            <span>info@gxg.world</span>
                        </li>
                    </ul>
                    <p className="text-[14px] text-white md:text-[16px] xl:absolute xl:left-0 xl:bottom-0">
                        Copyright ⓒ (재) 게임문화재단. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
